module.exports = __webpack_public_path__ + "static/img/h5.50a5694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/h5.png
// module id = Un46
// module chunks = 101